var _path, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidDocumentSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 146,
    viewBox: "0 0 126 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.5 12.5V26.5H125.5V12.5C125.5 5.59644 119.904 0 113 0H99V1H113C119.351 1 124.5 6.14873 124.5 12.5ZM1.5 119.5V133.5C1.5 139.851 6.64873 145 13 145H27V146H13C6.09644 146 0.5 140.404 0.5 133.5V119.5H1.5ZM124.5 119.5V133.5C124.5 139.851 119.351 145 113 145H99V146H113C119.904 146 125.5 140.404 125.5 133.5V119.5H124.5ZM1.5 26.5V12.5C1.5 6.14873 6.64873 1 13 1H27V0H13C6.09644 0 0.5 5.59644 0.5 12.5V26.5H1.5Z",
    fill: "#2EC973"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5286 31L38 31C31.3726 31 26 36.3726 26 43V107C26 113.627 31.3726 119 38 119H88C94.6274 119 100 113.627 100 107V43C100 36.3726 94.6274 31 88 31L63.5286 31Z",
    fill: "url(#paint0_linear_1103_10017)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7 16L26 16C19.3726 16 14 21.3726 14 28V122C14 128.627 19.3726 134 26 134H100C106.627 134 112 128.627 112 122V28C112 21.3726 106.627 16 100 16L63.7 16Z",
    fill: "url(#paint1_linear_1103_10017)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8389 89.1862C68.387 90.7678 68.387 93.3322 66.8389 94.9138L48.3389 113.814C47.5954 114.573 46.5871 115 45.5357 115C44.4843 115 43.476 114.573 42.7325 113.814L32.1611 103.014C30.613 101.432 30.613 98.8678 32.1611 97.2862C33.7093 95.7046 36.2193 95.7046 37.7675 97.2862L45.5357 105.222L61.2325 89.1862C62.7807 87.6046 65.2907 87.6046 66.8389 89.1862Z",
    fill: "url(#paint2_linear_1103_10017)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3608 105.394C45.4068 105.441 45.4699 105.467 45.5357 105.467C45.6015 105.467 45.6646 105.441 45.7106 105.394L61.4075 89.3574C62.8596 87.8739 65.2118 87.8739 66.664 89.3574C68.119 90.8439 68.119 93.2561 66.664 94.7426L48.164 113.643C47.466 114.356 46.5205 114.755 45.5357 114.755C44.5509 114.755 43.6054 114.356 42.9075 113.643L32.336 102.843C30.881 101.356 30.881 98.9439 32.336 97.4574C33.7882 95.9739 36.1404 95.9739 37.5925 97.4574L45.3608 105.394Z",
    stroke: "url(#paint3_linear_1103_10017)",
    strokeWidth: 0.489516,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2883 39.5724C85.4628 39.5565 85.6532 39.5565 85.8118 39.5724C89.5877 39.4454 92.5862 36.3517 92.6021 32.5441C92.6021 28.6572 89.4449 25.5 85.558 25.5C81.6552 25.5 78.5139 28.6572 78.5139 32.5441C78.5139 36.3517 81.5124 39.4454 85.2883 39.5724ZM77.8795 54.7394C74.0402 52.1851 74.0402 47.9967 77.8795 45.4266C82.2583 42.5233 89.4135 42.5233 93.7605 45.4266C97.5998 47.9809 97.5998 52.1692 93.7605 54.7394C89.3976 57.6586 82.2424 57.6586 77.8795 54.7394Z",
    fill: "url(#paint4_linear_1103_10017)",
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_b_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 85.5V25.5C112 18.8726 106.627 13.5 100 13.5H26C19.3726 13.5 14 18.8726 14 25.5V85.5",
    stroke: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_1103_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 85.5L14 124.5C14 131.127 19.3726 136.5 26 136.5L100 136.5C106.627 136.5 112 131.127 112 124.5L112 85.5",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1103_10017",
    x: 4,
    y: 9,
    width: 118,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_1103_10017"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1103_10017",
    x: 6,
    y: 8,
    width: 114,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1103_10017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1103_10017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1103_10017",
    x: 30,
    y: 88,
    width: 39,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1103_10017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1103_10017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1103_10017",
    x: 74,
    y: 25.5,
    width: 23.6399,
    height: 33.4288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1103_10017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1103_10017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_1103_10017",
    x: 8.5,
    y: 8,
    width: 109,
    height: 82.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1103_10017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1103_10017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_1103_10017",
    x: 8.5,
    y: 80.5,
    width: 109,
    height: 61.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1103_10017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1103_10017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1103_10017",
    x1: 112.95,
    y1: 40.3673,
    x2: 32.862,
    y2: 57.8537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC973",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1103_10017",
    x1: 129.15,
    y1: 28.5607,
    x2: 22.9688,
    y2: 51.4575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC973",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1103_10017",
    x1: 36.7821,
    y1: 98.2944,
    x2: 94.6289,
    y2: 104.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1103_10017",
    x1: 32.0519,
    y1: 91.8511,
    x2: 55.8023,
    y2: 99.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1103_10017",
    x1: 85.82,
    y1: 25.5,
    x2: 85.82,
    y2: 56.9288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentSuccess);
export default __webpack_public_path__ + "static/media/bfid-document-success.3c1036fae1713fc8bceabbbe2d08f927.svg";
export { ForwardRef as ReactComponent };